import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { CookieConsent } from '../../../components/common/cookie-consent/cookie-consent';
import { MainFooter } from '../../../components/main/main-footer/main-footer';
import { MainHeader } from '../../../components/main/main-header/main-header';
import { MainToolbar } from '../../../components/main/main-toolbar/main-toolbar';
@Component({
  selector: 'app-main-layout-page',
  imports: [
    RouterModule,
    MainHeader,
    MainToolbar,
    MatSidenavModule,
    MainFooter,
    CookieConsent,
  ],
  templateUrl: './main-layout-page.html',
  styleUrl: './main-layout-page.scss',
})
export class MainLayoutPage {}
